import { render, staticRenderFns } from "./purchasecomplete.vue?vue&type=template&id=cd2b6edc&scoped=true"
import script from "./purchasecomplete.vue?vue&type=script&lang=js"
export * from "./purchasecomplete.vue?vue&type=script&lang=js"
import style0 from "./purchasecomplete.vue?vue&type=style&index=0&id=cd2b6edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2b6edc",
  null
  
)

export default component.exports